// extracted by mini-css-extract-plugin
export default {"palleteContainer":"PriorityPallete_palleteContainer__jnx3v","labelOption":"PriorityPallete_labelOption__ImDxz"};